import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      // Show banner after a short delay for better UX
      const timer = setTimeout(() => setShowBanner(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
    // Reload to enable analytics and third-party scripts
    window.location.reload();
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <aside
      className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-slide-up"
      role="region"
      aria-label="Cookie consent"
    >
      <div className="container mx-auto max-w-4xl">
        <div className="bg-slate-900/95 backdrop-blur-md border border-amber-500/20 rounded-xl shadow-2xl shadow-black/50 p-4 sm:p-6">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            {/* Icon and Text */}
            <div className="flex items-start gap-3 flex-1">
              <div className="p-2 bg-amber-500/10 rounded-lg flex-shrink-0">
                <Cookie className="w-5 h-5 text-amber-400" aria-hidden="true" />
              </div>
              <div>
                <p className="text-gray-300 text-sm leading-relaxed">
                  We use cookies to enhance your browsing experience, analyze site traffic, and serve personalized content.
                  By clicking &quot;Accept&quot;, you consent to our use of cookies.{' '}
                  <Link
                    to="/privacy-policy"
                    className="text-amber-400 hover:text-amber-300 underline underline-offset-2"
                  >
                    Learn more about our privacy policy
                  </Link>
                </p>
              </div>
            </div>

            {/* Buttons */}
            <div className="flex items-center gap-3 w-full sm:w-auto">
              <button
                onClick={handleDecline}
                className="flex-1 sm:flex-none px-5 py-2.5 text-gray-400 hover:text-white border border-gray-600 hover:border-gray-500 rounded-lg text-sm font-medium transition-all duration-200"
              >
                Decline cookies
              </button>
              <button
                onClick={handleAccept}
                className="flex-1 sm:flex-none px-5 py-2.5 bg-gradient-to-r from-emerald-700 to-emerald-600 hover:from-emerald-600 hover:to-emerald-500 text-white rounded-lg text-sm font-semibold transition-all duration-200 shadow-lg shadow-emerald-900/30"
              >
                Accept cookies
              </button>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default CookieConsent;
